var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.widgetDetails.widgetCategoryID === 2)?_c('CalendarWidgetSettings',{attrs:{"widgetDetails":_vm.widgetDetails,"defaultCulture":_vm.defaultCulture}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }